import createReducer from 'shared/utils/createReducer';

import { GET_SESSION_INFO } from 'modules/session/actions/getSessionInfo';
import { USER_UPDATED } from 'modules/common/actions/onUserUpdates';
import { LOGIN } from '../actions/login';
import { LOGOUT } from '../actions/logout';
import { SEND_OTP_CODE } from '../actions/sendOtpCode';
import { TOS_NEED_APPROVE } from '../actions/termsOfService';
import { UPDATE_USER } from '../../user/actions/_api/updateUser';

const defaultState = {
  policyId: '',
  verificationToken: '',
  tosRequired: true,
  tosToken: null,
  secondaryLoginData: null,
  userId: null,
  profile: {},
  dynamicPermissions: [],
};

export default createReducer(defaultState, {
  [LOGIN.success]: (state, { payload: { policyId, verificationToken, phoneNumber, secondaryLoginData } }) => ({
    ...state,
    policyId,
    verificationToken,
    phoneNumber,
    secondaryLoginData,
  }),

  [TOS_NEED_APPROVE]: (state, { payload: { tosRequired, tosToken, externalId } }) => ({
    ...state,
    tosRequired,
    tosToken,
    policyId: externalId || state.policyId,
  }),

  [GET_SESSION_INFO.success]: (state, { payload: { user: { userId, profile, dynamicPermissions } } }) => ({
    ...state,
    userId,
    profile,
    dynamicPermissions,
  }),

  [SEND_OTP_CODE.success]: (state, { payload: { tosRequired, tosToken, user: { userId, profile, dynamicPermissions } } }) => ({
    ...state,
    tosRequired,
    tosToken,
    userId,
    profile,
    dynamicPermissions,
  }),

  [USER_UPDATED]: (state, { payload: { userId, profile, dynamicPermissions } }) => ({
    ...state,
    profile: userId === state.userId ? profile : state.profile,
    dynamicPermissions: userId === state.userId ? dynamicPermissions : state.dynamicPermissions,
  }),

  [UPDATE_USER.success]: (state, { payload }) => ({
    ...state,
    profile: { ...state.profile, ...payload },
  }),

  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
